const PURCHASE_TRACKED_KEY = 'myroomsai_ga4_purchases';

/**
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
  );
  window.gtag('event', eventName, clean);
}

/**
 * @returns {Set<string>}
 */
export function getTrackedPurchaseIds() {
  if (typeof window === 'undefined') return new Set();
  try {
    const raw = window.localStorage.getItem(PURCHASE_TRACKED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : []);
  } catch {
    return new Set();
  }
}

/**
 * @param {string} orderId
 */
export function markPurchaseTracked(orderId) {
  if (typeof window === 'undefined' || !orderId) return;
  const tracked = getTrackedPurchaseIds();
  tracked.add(orderId);
  try {
    window.localStorage.setItem(PURCHASE_TRACKED_KEY, JSON.stringify([...tracked]));
  } catch {
    /* ignore quota errors */
  }
}
